import { createAction } from 'redux-actions';

const actions = {
  /**
   * [버전] 버전 데이터 변경하기
   */
  SET_DATA: 'version/SET_DATA',
  setData: createAction('version/SET_DATA'),

  /**
   * [버전 전체 리스트] 버전 전체 리스트 요청하기
   */
  GET_VERSION_LIST_REQUEST: 'version/GET_VERSION_LIST_REQUEST',
  GET_VERSION_LIST_SUCCESS: 'version/GET_VERSION_LIST_SUCCESS',
  getVersionList: createAction('version/GET_VERSION_LIST_REQUEST'),

  /**
   * [버전 등록] 버전 등록 요청하기
   */
  INSERT_VERSION_REQUEST: 'version/INSERT_VERSION_REQUEST',
  insertVersion: createAction('version/INSERT_VERSION_REQUEST'),

  /**
   * [버전 편집] 버전 편집 요청하기
   */
  EDIT_VERSION_REQUEST: 'version/EDIT_VERSION_REQUEST',
  editVersion: createAction('version/EDIT_VERSION_REQUEST'),

  /**
   * [버전 삭제] 버전 삭제 요청하기
   */
  DELETE_VERSION_REQUEST: 'version/DELETE_VERSION_REQUEST',
  deleteVersion: createAction('version/DELETE_VERSION_REQUEST'),

  /**
   * [버전 상세] 버전 상세 요청하기
   */
  GET_VERSION_INFO_REQUEST: 'version/GET_VERSION_INFO_REQUEST',
  GET_VERSION_INFO_SUCCESS: 'version/GET_VERSION_INFO_SUCCESS',
  getVersionInfo: createAction('version/GET_VERSION_INFO_REQUEST'),
};

export default actions;
